import {
  SECTION_ANALYSIS,
  SECTION_BUDGET,
  SECTION_BUDGET_SETTINGS,
  SECTION_EMPLOYEE_MANAGEMENT,
  SECTION_OVERVIEW,
  SECTION_USERS,
  SECTION_WORKFORCE_SETTINGS,
} from "common/routes/sections/main.sections";

export const ADMINISTRATOR_SECTIONS = [SECTION_BUDGET_SETTINGS, SECTION_USERS];

export const COORDINATOR_SECTIONS = [
  SECTION_BUDGET,
  SECTION_OVERVIEW,
  SECTION_USERS,
  SECTION_WORKFORCE_SETTINGS,
  SECTION_ANALYSIS,
];

export const OWNER_SECTIONS = [SECTION_OVERVIEW];

export const HR_COORDINATOR_SECTIONS = [
  SECTION_WORKFORCE_SETTINGS,
  SECTION_EMPLOYEE_MANAGEMENT,
];
